import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios, { AxiosResponse } from 'axios';
import { PlanningsDeliveryWithLegRunEntity } from 'src/entities/PlanningsDelivery.entity';
import { CONVENIENCE_DISPATCH_DELIVERIES_QUERY_KEY } from './useConvenienceDispatchDeliveries.query';

const REQUEST_PATH = '/api/v5/convenience_dispatches/shift_trucks';

type RequestBody = {
  truck_id: number;
  start_at: string;
  end_at: string;
  driver_id?: number;
  labor_hours?: number;
};

export const useConvenienceDispatchShiftTruckMutation = () => {
  const queryClient = useQueryClient();

  return {
    create: useMutation(
      (body: RequestBody) => axios.post<PlanningsDeliveryWithLegRunEntity>(REQUEST_PATH, body),
      {
        onSuccess: (_response: AxiosResponse<PlanningsDeliveryWithLegRunEntity>) => {
          void queryClient.invalidateQueries({ queryKey: [CONVENIENCE_DISPATCH_DELIVERIES_QUERY_KEY] });
        },
      }
    ),
    // OFF にする操作: leg_run.operations を resetting (= 未割当に戻す) + shift_truck/shift を destroy
    destroy: useMutation(
      (shiftTruckId: number) => axios.delete<void>(`${REQUEST_PATH}/${shiftTruckId}`),
      {
        onSuccess: () => {
          void queryClient.invalidateQueries({ queryKey: [CONVENIENCE_DISPATCH_DELIVERIES_QUERY_KEY] });
        },
      }
    ),
    // 車両 / ドライバーの差し替え (アルゴリズム再計算なし)。
    // truck_id / driver_id のいずれかまたは両方を渡す。backend で uniqueness 衝突を回避する。
    update: useMutation(
      (args: { shiftTruckId: number; truckId?: number; driverId?: number }) => axios.patch(
        `${REQUEST_PATH}/${args.shiftTruckId}`,
        { truck_id: args.truckId, driver_id: args.driverId },
      ),
      {
        onSuccess: () => {
          void queryClient.invalidateQueries({ queryKey: [CONVENIENCE_DISPATCH_DELIVERIES_QUERY_KEY] });
        },
      },
    ),
  };
};
